import { useContext, useState, useEffect } from 'react';
import { AppContext } from '../../contexts/AppContext';
import EmployeesApi from '../../services/EmployeesApi';
import { decodeFileXLSX } from '../../utils/MiscellaneousUtils';
import { currentDateForFile } from '../../utils/DateUtils';
import { LoginContext } from '../../contexts/LoginContext';

const useEmployeesAdministrationPresenter = () => {
  const { isAdmin, userInfo } = useContext(LoginContext);
  const { showError, showSuccess } = useContext(AppContext);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [oldSearchRequest, setOldSearchRequest] = useState({});
  const [status, setStatus] = useState(null);
  const [loadingExport, setLoadingExport] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);


  useEffect(() => {
    console.log("Proveedor: ", selectedSupplier);
  }, [selectedSupplier])


  useEffect(() => {
    search();
  }, []);

  const cleanFilters = () => {
    setEmail('');
    setName('');
    setStatus(null);
    setSelectedSupplier(null);
  };

  const reloadGrid = () => search(true);

  const handleExport = ids => {
    setLoadingExport(true);
    
    const request = ids ? ids : rows.map(r => r.id) ;

    EmployeesApi.exportToExcel(request)
      .then(res => decodeFileXLSX(res, `Empleados_${currentDateForFile()}.xlsx`))
      .catch(error => showError('No se pudo descargar el archivo solicitado'))
      .finally(() => setLoadingExport(false));

  };

  const handleDisable = selectedEmployee => {
    const request = {
      EmployeeId : selectedEmployee
    }

    EmployeesApi.disableEmployee(request)
      .then(res => showSuccess("El empleado fue deshabilitado"))
      .catch(error => showError("Error al deshabilitar al empleado"))
      .finally(() => reloadGrid());
  }

  const handleEnable = selectedEmployee => {
    const request = {
      EmployeeId : selectedEmployee
    }

    EmployeesApi.enableEmployee(request)
      .then(res => showSuccess("El empleado fue habilitado"))
      .catch(error => showError("Error al habilitar al empleado"))
      .finally(() => reloadGrid());
  }

  const search = reload => {
    const request = reload
      ? oldSearchRequest
      : {
          Email : email || undefined,
          Fullname: name || undefined,
          Enabled: status ? status === 'true' : undefined,
          SupplierId: isAdmin ? (selectedSupplier ? selectedSupplier.id : undefined) : userInfo.id,
        };

    setFirstLoad(false);
    setLoading(true);
    setOldSearchRequest(request);

    EmployeesApi.getManagement(request)
      .then(res => {
        setRows(res.data);
      })
      .catch(error => {
        showError('Error al obtener los empleados');
      })
      .finally(() => setLoading(false));
  };

  const validateFilters = () => {
    // let errors = [];
    // const errorMessages = [];
    // let i = 0;

    // if ((errors[i++] = !isSupplier && !selectedSupplier)) {
    //   errorMessages.push('Debe seleccionar un proveedor para iniciar la búsqueda');
    // }

    // if ((errors[i++] = dateFrom && !dateTo)) {
    //   errorMessages.push('Debe completar el rango de fechas o quitar la Fecha desde');
    // }

    // if ((errors[i++] = !dateFrom && dateTo)) {
    //   errorMessages.push('Debe completar el rango de fechas o quitar la Fecha hasta');
    // }

    // const hasErrors = errors.some(e => e);

    // hasErrors && showWarning(errorMessages);

    // return !hasErrors;

    return true
  };

  const validateAndSearch = () => validateFilters() && search();

  return {
    isAdmin,
    name,
    setName,
    email,
    setEmail,
    status,
    setStatus,
    validateAndSearch,
    cleanFilters,
    rows,
    loading,
    firstLoad,
    reloadGrid,
    selectedSupplier,
    setSelectedSupplier,
    gridFunctions: {
      gridActions: {
        handleEnable,
        handleDisable,
        loadingExport,
        handleExport,
        selectedSupplier,
        reloadGrid
      }
    }
  };
};

export default useEmployeesAdministrationPresenter;
